module.exports = __webpack_public_path__ + "img/ic_unlike.ad5e1581.svg";